export const REDIRECT_LOCATIONS = {
    Search: 0,
    Assets : 1,
    Activity: 2
};